const zh={
    common:{
        yes:"是",
        no:"否",
        verfRequirement:"验证信息",
        baseInfo:"企业基本资料",
        clientNameLocal:"公司名称(当地语言)",
        clientNameLocalError:"公司名称不能为空",
        clientNameEn:"公司名称(英文)",
        addressLocal:"地址(当地语言)",
        addressLocalError:"地址不能为空",
        addressEn:"地址(英文)",
        industry:"所属行业",
        businessType:"企业性质",
        pleaseDetail:"请说明",
        contactInfo:"填报人信息",
        contact:"联系人",
        contactError:"联系人不能为空",
        mobile:"手机号码",
        mobileError:"手机号码不能为空",
        email:"邮箱地址",
        emailError:"邮箱地址不能为空",
        countryError:"请选择国家",
        taxCodeError:"纳税人识别号不能为空",
        title:"职位",
        titleError:"职位不能为空",
        submit:"提交",
        hotline:"服务热线",
        moreService:"更多服务",
        successMsg:"您的申请已提交，我们将尽快联系您，服务热线：+86 755 21608956",
        view:"查看",
        selectFile:"选择文件", 
        verificationDate:"验证日期",
        pleaseSelectFile:"请选择文件",
        download:"下载",
        delete:"删除",
        uploadFile:"上传文件",
        taxCode:"纳税人识别号",
        country:"国家",
        province:"省份",
        station:"周边高铁站或机场名称",
        requiredError:"这是必填项，请输入",
        numericError:"请输入数字"   
    },
    actions:{
        new:"新建",
        view:"查看",
        edit:"修改",
        status:"状态",
        followup:"跟进",
        delete:"删除",
        actions:"操作",
        refresh:"刷新",
        back:"返回",
        share:"分享",
        submit:"提交",
        search:"搜索",
        download:"下载",
        close:"关闭",
        copy:"复制",
        cancel:"取消",
        ok:"确定",
        add:"新增",
        createAppForm:"生成申请表",
        downAppForm:"下载申请表",
        send:"发送",
        createQuotaion:"生成报价书",
        createContract:"生成合同",
        archivingContract:"归档合同",
        archivingApplicationForm:"归档申请表",
        invoice:"开票信息",
        downContract:"下载合同",
        bindingClient:"绑定客户",
        newClient:"新建客户",
        binding:"绑定",
        assignSales:"分配销售",
        assignCS:"分配客服",
        createInvoice:"生成形式发票",
        archivingInvoice:"归档形式发票",
        downInvoice:"下载形式发票",
        internalSharing:"内部分享",
        feedback:"反馈",
        confirm:"确认",
        argue:"争议",
        upload:"上传",
        save:"保存",
        cancelReason:"取消原因"
    },
    generalService:{
        title:"常规服务申请",
        serviceInfo:"服务信息",
        serviceType:"服务类型",
        serviceDate:"期望服务日期",
        serviceDateError:"期望服务日期不能为空"
    },    
    fem:{
        pageTitle:"Higg FEM 验证申请",
        formName:"Higg FEM 验证申请",
        type:"验证类型",
        typeFoundation:"Foundation - 不参与评分，验证过去12个月的数据和记录",
        typeFEM:"FEM - 有评分系统，验证过去一个自然年的数据和记录，请勾选下面各模块自评完成度",
        self:"自评完成度",
        envManagementSystem:"环境管理体系",
        energyGreenhouseGases:"能源和温室气体",
        waterResources:"水资源",
        wastewater:"废水",
        exhaustEmissions:"废气排放",
        waste:"废弃物",
        chemicalManagement:"化学品管理",
        experience:"验证经验",
        experience1:"首次",
        experience2:"第二次",
        experience3:"第三次和以上",
        model:"验证模式",
        model1:"环境评估现场验证",
        model2:"环境评估远程验证（*需贵司征求最终品牌客户的同意）",
        selfassessment:"自我评估已经完成",
        promoteBrand:"推动客户",
        auditDate:"期望验证日期",
        auditDateError:"期望验证日期不能为空",
        productType:"产品类型和产量",
        technology:"主要生产工艺（可提供工艺流程图代替）",
        chemical:"生产过程中是否使用化学品？举例",
        wwt:"是否有废水处理站",
        coverarea:"占地面积",
        coverareaError:"请填写面积",
        employee:"员工人数",
        employeeError:"请填写员工人数",
        esc:"环境体系证书"
    },
    slcp:{
        formName:"SLCP 验证申请",
        type:"验证需求",
        experience:"验证经验",
        experience1:"首次验证",
        experience2:"年度验证",
        experience3:"跟进验证",
        selfassessment:"自我评估已经完成",
        postDate:"自评提交日期",
        ahSystem:"AH托管平台",
        other:"其他",
        promoteBrand:"推动客户",
        announcementType:"通知类型",
        announcementType1:"通知",
        announcementType2:"不通知",
        announcementType3:"半通知（10天）",
        auditDate:"期望验证日期",
        auditDateError:"期望验证日期不能为空",
        model:"验证形式",
        model1:"现场验证",
        model2:"视频验证",
        model3:"现场验证+视频验证",
        apsca:"是否需要APSCA验证员",
        employee:"工人人数",
        employeeError:"工人人数必填",
        manager:"主管人数",
        managerError:"主管人数必填",
        csr:"CSR管理体系证书（如：BSCI、WRAP、ISO等）",
        serviceProvider:"企业现场其他服务供应商",
        productionBuildings:"生产建筑数量",
        dormitories:"宿舍数量",
        warehouses:"仓库数量",
        otherBuildings:"其他建筑数量",
        productType:"主要产品",
        technology:"主要工序",
        times:"次",
        tipWorker:"温馨提醒:请根据工人的定义确保填报的人数是准确的",
        tipManager:"温馨提醒:确保填报的主管人数是准确的",
        workerInclude:"工人包括：",
        workerDetail:"1.直接参与产品生产的人员，即生产线上的一线操作员，如车缝工，裁剪工，包装工等等；2.非直接生产产品，但参与到生产流程中一线工人，如品检工，机修工，电工，搬运工，收发料工人等。",
        workerExclude:"工人不包括：",
        workerExDetail:"任何监督性的岗位，即任何有‘管理’职责的人，如缝纫组组长，机修班班长等。"       

    },
    application_confirm:{
        applicationForm:"申请书",
        applicationFormUpload:"服务申请书上传",
        notExist:"申请单不存在",
        error:"申请单异常",
        success:"申请书已提交,我们将尽快提供报价，服务热线：+86 755 21608956",
        submitError:"申请书提交异常, 请联系我们: +86 755 21608956",
        pleaseSelectfile:"请选择签字盖章申请书"
    },
    confirm_letter:{
        confirmLetter:"确认函回执",
        notExist:"服务单不存在",
        error:"服务单异常",
        success:"排期已确认，服务热线：+86 755 21608956",
        submitError:"提交异常, 请联系我们: +86 755 21608956",
    },
    verfDocument:{
        verfDocument:"验证文档",
        pre:"预审文档",
        other:"其他文档",
        file:"文件名",
        updateTime:"更新时间",
        size:"文件大小",
        status:"预审状态",
        comments:"预审结论",
        preTitle:"Higg FEM预审包括",
        pre1:"能源: 一年能耗清单excel表（2022-2024）,能源/燃料采购发票/读表记录（2022-2024）",
        pre2:"水: 一年水源和用水量清单excel表（2022-2024）,用水采购发票/读表记录（2022-2024）",
        pre3:"废水:工业废水/生活废水量清单(2024),发票/读表记录（2024）,估算方法（若适用）",
        pre4:"废气: 各种制冷剂清单以及用量Excel表（2024）,发票/读表记录（2024）,估算方法（若适用）",
        pre5:"废弃物:非危废清单以及产生量excel表（2024）,危废清单以及产生量excel表（2024）,称重记录/发票/处理记录,估算方法（若适用）",

    },
    traningSurvey:{
        title:"GreenPont培训调查问卷",
        question1:"1、您参加的培训课题",
        question2:"2、您参加培训的时间",
        question3:"1、此次课程内容是否解答您的项目疑问？",
        question4:"2、此次课程内容对您项目工作实施是否有指导作用？",
        question5:"3、此次课程对您工作理解及实施是否有关联性、启发性？",
        question6:"4、此次课程教材设置是否具备结构条理性，易于检索？",
        question7:"5、课程授课讲师是否逻辑清晰、重点突出？",
        question8:"6、此次课程授课讲师是否融入丰富的良好案例及练习？",
        question9:"7、此次课程讲师是否良好把握课程进度？",
        question10:"8、请对此次课程行政人员态度、责任心及服务总体评价！",
        question11:"9、请对此次培训工具便捷性、易操作性进行评价！",
        question12:"10、如有其他建议及补充，欢迎提出！",
        nonExist:"培训课程不存在",
        error:"数据异常",
        success:"感谢您的反馈",
        submiterror:"数据提交异常，请联系管理员:+86 755 21608956",
        nameerror:"课程名称不能为空",
        dateerror:"课程时间不能为空"
    },
    aws:{
        formName:"AWS项目认证申请表",
        applicantInformation:"申请方信息",
        facility:"场所",
        desiredCertificationLevel:"期望审核级别",
        certificationType:"认证类型",
        auditType: "审核类型",
        factoryName:"工厂名称",
        referenceNumber:"AWS 参考编号",
        address:"地址",
        employees:"员工数目",
        occupiedArea:"占地面积（单位：平方米）",
        mainProducts:"主要产品/服务",
        mainManufacture:"大致生产工序流程",
        wastewater:"是否产生工业废水",
        annualWater:"年度用水量（单位：吨）",
        sourceWater:"用水来源(选择所有适用的)",
        wastewaterReused:"是否有回用水/循环用水设备<br>如果有，请大致描述：<br>-	每月回用/循环利用多少吨废水？<br>-	回用/循环利用的主要过程是什么？<br>-回用/循环水利用在哪里？",
        wastewaterTreatmentPlant:"是否有废水处理装置？",
        dischargedWastewater:"废水排放去向?",
        reason:"理由",
        certLevError:"请选择期望审核级别",
        certTypeError:"请选择认证类型",
        auditTypeError:"请选择审核类型",
        factoryNameError:"请输入工厂名称",
        addressError:"请输入工厂地址",
        employeesError:"请输入员工数目",
        occupiedAreaError:"请输入占地面积",
        mainProductsError:"请输入主要产品/服务",
        mainManufactureError:"请输入大致生产工序流程",
        wastewaterError:"请输入是否产生工业废水"
    },
    zero:{
        formName:"SUPPLIER TO ZERO LEVEL 2 REVIEW申请",
        experience:"Supplier to Zero level 2 验证经验",
        finishLevel1:"是否完成Supplier to Zero level 1的验证",
        model:"验证模式",
        zdhcID:"ZDHC网关ID",
        openingHour:"年运行时间（小时）",
        fromFactoryAirport:"工厂到机场/高铁站的距离（汽车）",
        cmc:"化学品管理证书",
        numberofChemical:"工厂的化学品库存数量",
        mrsl:"MRSL符合性证书",
        chemicalUsed:"化学品使用数量",
        materials:"主要原辅料",
        serviceDate:"期望服务日期",
    },    
    zdhc:{
        formName:"ZDHC VERIFIED INCHECK LEVEL 1申请",
        experience:"ZDHC Verified Incheck Level 1 验证经验",
        performance:"过去三个月或连续三个季度的绩效检查报告是否完整",
        model:"验证类型",
        productionArea:"生产区面积",
        administration:"办公区面积",	
        chemicalStorageArea:"化学品储存区面积",
        other:"其他区域面积"	
    },
    ghg:{
        formName:"碳盘查信息收集表",
        year:"年份",
        energySource:"生产阶段消耗能源品种",
        multipleSite:"是否涉及多场址",
        involvesNewEnergy:"是否涉及使用新能源",
        onsitePowerGeneration:"是否涉及自发电",
        energySupplytoOtherSites:"是否涉及向外部单位转供电",
        carbonOffset:"是否涉及碳抵消",
        mainProduction:"主要生产设备",
        onsiteCanteen:"厂区内是否涉及食堂和宿舍",
        subcontractedProcess:"是否涉及生产外包",
        millsLease:"是否涉及厂房的出租",
        operationFacility:"主要生产辅助设施（如配电房，污水站，废气处理设施，中央空调，空压机等",
        sitEnergyMeteringMap:"请提供厂区能源计量图",
        chemicalInventory:"请提供主要化学品清单（含特种气体）",
        fireExtinguisher:"是否使用二氧化碳灭火器",
        fireSuppressionSystem:"是否使用七氟丙烷灭火系统",
        wawHandlingProcess:"请提供三废处理工艺"
    },
    survey:{
        q1:"请评价我们的服务提供的及时性（电话、邮件回复和方案提交）",
        q2:"请评价我们解疑答惑的清晰程度",
        q3:"请评价我们的技术支持程度",
        q4:"请评价我们的客服支持程度",
        q5:"请评价我们现场交付的效率",
        q6:"请评价我们验证工作的沟通技巧",
        q7:"请评价我们验证的准确性",
        q8:"请评价我们的验证员的准时性，处理问题的能力和个人表现",
        q9:"您是如何看待我们验证员在贵行业的专业知识？",
        q10:"您是否认为整个验证过程中，我们的评估是准确、清晰和有条理的？",
        q11:"首末次会议的时候，您是否收到和本次验证有关的详细信息以及审核结果？",
        q12:"您的问题是否得到满意的回答？",
        q13:"请评价我们报告提交的准时率",
        q14:"您还会继续使用GreenPont来进行验证吗？",
        q15:"您是如何评价我们验证员的知识和技能程度？",
        q16:"您会向其他同事或者熟人推荐GreenPont吗？",
        q17:"整体来说，您对GreenPont服务的满意程度如何？",
        suggestion:"建议",
        formName:"服务满意度调查表",
        companyName:"企业名称",
        feedback:"感谢您的反馈",
        feedbackError:"满意度调查反馈异常，请联系管理员"
    },
    fpa:{
        formName:"在线信息收集表",
        experience:"第几次跟进审核",
        auditDate:"审核窗口",
        attachment:"供应商审核报告（需跟进的问题点报告）",
        brandContactInfo:"客户联系人",
        auditRequirement:"审核信息",
        announcementType3:"半通知",
        specialNotes:"特殊备注",
        auditDateError:"请输入审核窗口",
        contactSC:"排期接收人",
        contactRP:"报告接收人",
        contactAT:"ZT提醒接收人"
    },
}
export default zh